function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("title", null, "correct");

var _ref3 = /*#__PURE__*/React.createElement("g", {
  id: "Symbols",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("g", {
  id: "radio-/-correct"
}, /*#__PURE__*/React.createElement("g", {
  id: "correct"
}, /*#__PURE__*/React.createElement("circle", {
  id: "Oval-Copy-2",
  fill: "#009F4D",
  cx: 16,
  cy: 16,
  r: 16
}), /*#__PURE__*/React.createElement("path", {
  d: "M13.3734284,22.3156564 L23.9136865,11.775364 C24.0784467,11.6106381 24.0784467,11.3434993 23.9136865,11.1787391 L22.9193575,10.1843758 C22.7545973,10.0196499 22.4874928,10.0196499 22.3227326,10.1843758 L13.075116,19.4319925 L9.67722445,16.0341009 C9.51246426,15.8693407 9.24535979,15.8693407 9.08056526,16.0341009 L8.08623627,17.0284299 C7.92147607,17.1931901 7.92147607,17.4602946 8.08623627,17.6250891 L12.7768035,22.3156564 C12.9415294,22.4803823 13.2086339,22.4803823 13.3734284,22.3156564 Z",
  id: "c",
  fill: "#FFFFFF",
  fillRule: "nonzero"
}))));

var SvgCorrect = function SvgCorrect(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "32px",
    height: "32px",
    viewBox: "0 0 32 32",
    ref: svgRef
  }, props), title === undefined ? _ref2 : title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref3);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgCorrect, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/correct.d0ac8581.svg";
export { ForwardRef as ReactComponent };